function append (obj, key, value, maxSize) {
  if (obj) {
    delete obj[key];

    const keys = Object.keys(obj);
    const objectLength = keys.length

    if (objectLength > maxSize - 1) {
      delete obj[keys[0]];
    }
  } else {
    obj = {};
  }
  obj[key] = value;

  return obj;
}

function getObjectValue (obj, key, checkLength = true, defaultValue = null) {
  if (!obj || !(key in obj)) {
    return defaultValue;
  } else if (checkLength) {
    return obj[key].length > 0 ? obj[key] : defaultValue;
  }

  return obj[key];
}

export { append, getObjectValue };
